import { isNil } from 'lodash/fp';
import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { notEmpty, createBackgroundAction } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import prefix from '../prefix';
import { setDepartments } from '../ducks/departments';

export interface Department {
    id: string;
    name: string;
}

export interface DepartmentResult {
    departments?: Array<Department> | null;
}

export const fetchDepartments =
    (enterpriseId: string): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container }) => {
        const { departmentsComponent } = container();

        const meta = {
            scope: enterpriseId,
        };

        const promise = departmentsComponent
            .getAll({
                enterpriseId,
            })
            .then(({ departments }: DepartmentResult) => {
                if (!isNil(departments) && notEmpty(departments)) {
                    dispatch(setDepartments(departments, enterpriseId));
                }
            });

        return dispatch(createBackgroundAction(DEPARTMENTS_FETCH, promise, meta));
    };

export const DEPARTMENTS_FETCH = prefix('DEPARTMENTS_FETCH');

export const fetchCurrentEnterpriseDepartments = (): CommanderThunkAction => async (dispatch) => {
    const currentEnterpriseId = getCurrentEnterpriseId();
    return dispatch(fetchDepartments(currentEnterpriseId));
};
